import React from 'react';
import {
  Box,
  Container,
  Paper,
  Typography,
  Button,
  Divider,
} from '@mui/material';
import GoogleIcon from '@mui/icons-material/Google';

const API_URL = process.env.REACT_APP_SECUREIFY_API_URL;

function Login() {
  const handleGoogleLogin = () => {
    window.location.href = `${API_URL}/auth/google`;
  };

  return (
    <Box
      sx={{
        minHeight: '100vh',
        pt: 8,
        pb: 6,
        display: 'flex',
        alignItems: 'center',
      }}
    >
      <Container maxWidth="sm">
        <Paper
          elevation={3}
          sx={{
            p: 4,
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
          }}
        >
          <Typography component="h1" variant="h4" gutterBottom>
            Welcome to Secureify
          </Typography>
          <Typography variant="body1" color="text.secondary" align="center" sx={{ mb: 4 }}>
            Sign in to access your dashboard and manage your API keys
          </Typography>
          
          <Button
            variant="contained"
            size="large"
            startIcon={<GoogleIcon />}
            onClick={handleGoogleLogin}
            fullWidth
            sx={{ mb: 2 }}
          >
            Sign in with Google
          </Button>

          <Divider sx={{ width: '100%', my: 3 }} />

          <Typography variant="body2" color="text.secondary" align="center">
            By signing in, you agree to our Terms of Service and Privacy Policy
          </Typography>
        </Paper>
      </Container>
    </Box>
  );
}

export default Login;
